module.exports = __webpack_public_path__ + "static/media/0004.91d8eae8.jpg";